module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/110.d75691a1.png";